// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myrow {
  display: flex;
}

.thButtonCOl {
  display: flex;
  flex-basis: 140px;
}

.th3 {
  display: flex;
  flex-basis: 300px;
  position: relative;
  z-index: 213332;
}

.td3 {
  display: flex;
  flex-basis: 300px;
  position: relative;
  z-index: 22;
  padding: 0px 3px;
}

.td1 {
  display: flex;
  flex-basis: 80px;
}

.td1displayfield {
  display: flex;
  flex-basis: 225px;
}

.td2 {
  display: flex;
  flex-basis: 20px;
}

.td12 .checkMarkInTd {
  display: none;
}

.td12:hover .checkMarkInTd {
  display: block;
}

.tdCheckBox {
  max-height: 60px;
}

.thDisplayName {
  flex-basis: 300px;
  display: flex;
}

.td12 {
  position: relative;
  z-index: 22;
  display: flex;
  flex-basis: 40px;
  padding: 5px;
}

.td15 {
  flex-basis: 70px;
}

.tDwidtherOnHover {
  transition: flex-basis 0.3s;
}

.tDwidtherOnHover:hover span {
  width: 35px;
  padding-left: 10px;
}

.tDwidtherOnHover:hover {
  flex-basis: 65px;
  cursor: pointer;
}

.tDwidtherOnHover1:hover {
  flex-basis: 90px;
  cursor: pointer;
}

.nottDwidtherChecked {
  flex-basis: 20px;
}

.tDwidtherChecked {
  flex-basis: 45px;
  cursor: pointer;
}

.tDwidtherChecked1 {
  flex-basis: 90px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/components/view-table/table-header/table-header.component.scss"],"names":[],"mappings":"AACA;EACE,aAAA;AAAF;;AAMA;EACE,aAAA;EACA,iBAAA;AAHF;;AAMA;EACE,aAAA;EACA,iBAAA;EAIA,kBAAA;EACA,eAAA;AANF;;AAUA;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAPF;;AAUA;EACE,aAAA;EACA,gBAAA;AAPF;;AASA;EACE,aAAA;EACA,iBAAA;AANF;;AASA;EACE,aAAA;EACA,gBAAA;AANF;;AASA;EACE,aAAA;AANF;;AASA;EACE,cAAA;AANF;;AASA;EACE,gBAAA;AANF;;AASA;EACE,iBAAA;EACA,aAAA;AANF;;AASA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AANF;;AASA;EACE,gBAAA;AANF;;AAaA;EACE,2BAAA;AAVF;;AAaA;EACE,WAAA;EACA,kBAAA;AAVF;;AAaA;EACE,gBAAA;EACA,eAAA;AAVF;;AAaA;EACE,gBAAA;EACA,eAAA;AAVF;;AAaA;EACE,gBAAA;AAVF;;AAaA;EACE,gBAAA;EACA,eAAA;AAVF;;AAaA;EACE,gBAAA;EACA,eAAA;AAVF","sourcesContent":["\n.myrow {\n  display: flex;\n  //display: -webkit-box;\n  //border-bottom: 1px solid #a3a1a3;\n}\n\n\n.thButtonCOl {\n  display: flex;\n  flex-basis: 140px;\n}\n\n.th3 {\n  display: flex;\n  flex-basis: 300px;\n  //padding: 5px;\n  //color: white;\n  //height: 35px;\n  position: relative;\n  z-index: 213332;\n  //background-color: rgba(42, 45, 69, 0.95);\n}\n\n.td3 {\n  display: flex;\n  flex-basis: 300px;\n  position: relative;\n  z-index: 22;\n  padding: 0px 3px;\n}\n\n.td1 {\n  display: flex;\n  flex-basis: 80px;\n}\n.td1displayfield {\n  display: flex;\n  flex-basis: 225px;\n}\n\n.td2 {\n  display: flex;\n  flex-basis: 20px;\n}\n\n.td12 .checkMarkInTd {\n  display: none;\n}\n\n.td12:hover .checkMarkInTd {\n  display: block;\n}\n\n.tdCheckBox {\n  max-height: 60px;\n}\n\n.thDisplayName {\n  flex-basis: 300px;\n  display: flex;\n}\n\n.td12 {\n  position: relative;\n  z-index: 22;\n  display: flex;\n  flex-basis: 40px;\n  padding: 5px;\n}\n\n.td15 {\n  flex-basis: 70px;\n}\n\n.td12marginTop {\n  //margin-top: 5px;\n}\n\n.tDwidtherOnHover {\n  transition: flex-basis 0.3s;\n}\n\n.tDwidtherOnHover:hover span {\n  width: 35px;\n  padding-left: 10px;\n}\n\n.tDwidtherOnHover:hover {\n  flex-basis: 65px;\n  cursor: pointer;\n}\n\n.tDwidtherOnHover1:hover {\n  flex-basis: 90px;\n  cursor: pointer;\n}\n\n.nottDwidtherChecked {\n  flex-basis: 20px;\n}\n\n.tDwidtherChecked {\n  flex-basis: 45px;\n  cursor: pointer;\n}\n\n.tDwidtherChecked1 {\n  flex-basis: 90px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
